// @ts-strict-ignore
import { RuleEditorDropdownMode } from '../../NodeEditorDrawer/types';
import { MULTISELECT_PROPS } from '../../constants';

export function getMultiSelectProps(mode: RuleEditorDropdownMode, isDisabled?: boolean) {
  return {
    ...MULTISELECT_PROPS,
    customStyleFunctions: {
      ...MULTISELECT_PROPS.customStyleFunctions,
      container: styles => ({
        ...styles,
        margin: '0',
      }),
      singleValue: styles => ({
        ...styles,
        borderTop: '2px solid transparent',
        fontFamily: 'var(--cl-font-family-mono)',
        fontSize: 'var(--cl-font-size-2)',
        color: 'var(--cl-text-default)',
        fontWeight: 'bold',
      }),
      valueContainer: styles => ({
        ...styles,
        padding: mode === RuleEditorDropdownMode.CARET_MLA_COMPONENT ? '0 1px' : '0 3px',
        caretColor: 'var(--cl-yellow-500)',
        opacity: isDisabled ? 0.5 : 1,
      }),
    },
  };
}
